import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useGlobalAPIQueryContext } from "@dev2_techwalnut/tw-api-query-hook";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";

const CreateSupplier = ({
    modal,
    goback,
    currentItem,
    refetchSuppliers,
    handleCloseModal,
}) => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();

    // select dropdown
    const [item, setItem] = useState([]);

    const backFromModal = () => {
        const button = document.createElement("button");
        button.className = "d-none";
        button.id = "create-po-modal-back-button";
        button.setAttribute("data-bs-toggle", "modal");
        button.setAttribute("data-bs-target", `#create-po-modal`);
        document.body.appendChild(button);
        button.click();
        button.remove();
    };

    const closeModal = () => {
        handleCloseModal();
    };

    const { invalidateApi } = useGlobalAPIQueryContext();

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useCreate } = useAPIQuery({
        key: "supplier",
        endpoint: "/api/supplier/",
    });

    const handleCreateSupplier = (data) => {
        console.log(data);
        if (refetchSuppliers) {
            refetchSuppliers();
        }
        Swal.fire({
            title: "Supplier Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                invalidateApi({ key: "supplier-item" });
                setTimeout(() => {
                    if (modal && goback) {
                        backFromModal();
                    } else if (modal && !goback) {
                        closeModal();
                    } else {
                        navigate(-1);
                    }
                }, 2000);
            }
        });
    };

    const handleErrorSupplier = (data) => {
        Swal.fire({
            title: "Error Adding Supplier",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateSupplier,
        // onError: handleErrorSupplier,
        errorMessageFromServer: true,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        setValue,
    } = useForm();

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        console.log(data);
        let supplier = new FormData();
        supplier.append("first_name", data.first_name);
        supplier.append("last_name", data.last_name);
        supplier.append("email", data.email);
        supplier.append(
            "item_list",
            data?.item_id?.map((api) => api?.value).join(",")
        );
        supplier.append("gst_number", data.gst_no);
        supplier.append("gst_certificate", data.gst_cert);
        // supplier.append("additional_docs", data.additional_docs);
        supplier.append("mobile_no", data.phone_number);
        supplier.append("address", data.address);
        supplier.append("created_by", userID);
        supplier.append("updated_by", userID);

        for (var pair of supplier.entries()) {
            console.log(pair);
        }

        mutate({
            data: supplier,
        });
    };

    useEffect(() => {
        if (data) {
            setItem(data.item.filter((api) => api.category === "Raw Material"));
        }
    }, [data]);

    useEffect(() => {
        if (currentItem) {
            setValue("item_id", [
                {
                    value: currentItem?.id,
                    label: currentItem?.item_name,
                },
            ]);
        }
    }, [currentItem]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Create Supplier </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Email Address
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter email address"
                                        id="email-forms-email"
                                        {...register("email", {
                                            required: true,
                                        })}
                                    />
                                    {errors.email && (
                                        <span className="fs-8 text-danger">
                                            Email Address is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label: api.item_name,
                                                    };
                                                })}
                                                isDisabled={modal}
                                                isMulti
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item_id"
                                            />
                                        )}
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter first name"
                                        id="text-forms-first_name"
                                        {...register("first_name", {
                                            required: false,
                                        })}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter last name"
                                        id="text-forms-last_name"
                                        {...register("last_name", {
                                            required: false,
                                        })}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label"
                                            htmlFor="input-tel-optional_phone_field"
                                        >
                                            Phone Number
                                        </label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="tel"
                                                className="form-control"
                                                placeholder="Enter phone number"
                                                {...register("phone_number", {
                                                    validate: (value) => {
                                                        if (!value) return true;
                                                        const phoneRegex =
                                                            /^\+?[1-9]\d{6,14}$/;
                                                        return (
                                                            phoneRegex.test(
                                                                value
                                                            ) ||
                                                            "Invalid phone number format"
                                                        );
                                                    },
                                                })}
                                            />
                                            {errors?.phone_number && (
                                                <small className="text-danger mt-1">
                                                    {
                                                        errors?.phone_number
                                                            ?.message
                                                    }
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Address
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter your address"
                                        id="text-forms-address"
                                        {...register("address", {
                                            required: true,
                                        })}
                                    ></textarea>
                                    {errors.address && (
                                        <span className="fs-8 text-danger">
                                            Address is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        GST Number
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter gst number"
                                        id="text-forms-gst_no"
                                        {...register("gst_no", {
                                            required: true,
                                        })}
                                    />
                                    {errors.gst_no && (
                                        <span className="fs-8 text-danger">
                                            GST number is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        GST Certificate
                                    </label>
                                    <Controller
                                        name="gst_cert"
                                        control={control}
                                        rules={{
                                            required: false,
                                            // validate: (value) => {
                                            //   const fileType = value?.[1]?.type;
                                            //   return (
                                            //     fileType === "application/pdf"
                                            //   );
                                            // },
                                        }}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <input
                                                className="form-control"
                                                id="file-forms-gst_cert"
                                                type="file"
                                                onChange={(e) => {
                                                    field.onChange(
                                                        e.target.files[0]
                                                    );
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Additional Documents
                                    </label>
                                    <Controller
                                        name="additional_docs"
                                        control={control}
                                        rules={{
                                            required: false,
                                            // validate: (value) => {
                                            //   const fileType = value?.[1]?.type;
                                            //   return (
                                            //     fileType === "application/pdf"
                                            //   );
                                            // },
                                        }}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <input
                                                className="form-control"
                                                id="file-forms-additional_docs"
                                                type="file"
                                                onChange={(e) => {
                                                    field.onChange(
                                                        e.target.files[0]
                                                    );
                                                }}
                                            />
                                        )}
                                    />
                                </div> */}

                                <div className="col-12">
                                    <div className="form-group">
                                        {modal ? (
                                            <button
                                                type="button"
                                                className="btn btn-md btn-light me-2"
                                                id="submit-button-backbutton"
                                                data-bs-toggle="modal"
                                                data-bs-target="#assign-supplier-to-item-modal"
                                            >
                                                Back
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-md btn-light me-2"
                                                id="submit-button-backbutton"
                                                onClick={() => navigate(-1)}
                                            >
                                                Back
                                            </button>
                                        )}
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-supplier-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-supplier"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateSupplier;
